import styled from "styled-components"
import { viewSizeCalculator } from "../../utils"

export const Wrapper = styled.div`
  display:flex;
  align-items:center;
  justify-content: center;
  padding: ${() => `${viewSizeCalculator(0.6875)} ${viewSizeCalculator(2.75)}`};
`

export const Text = styled.p`
font-family: Inter;
font-weight: 400;
font-size: ${() => `${viewSizeCalculator(0.625)}`};
line-height: 100%;
letter-spacing: 0%;
opacity: 30%;
color: #000000;
`